module.exports = __webpack_public_path__ + "static/media/icon-back.0c44ae0d.svg";